// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ isBadFile: boolean }>;

export const DispatchSetIsBadFile: HandlerType = props => {
    props.dispatch({
        type: "Greif/Components/GreifOrderUpload/SetIsBadFile",
        parameter: props.parameter,
    });
};

export const chain = [DispatchSetIsBadFile];

const setIsBadFile = createHandlerChainRunner(chain, "SetIsBadFile");
export default setIsBadFile;
